let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kONGf")).then(() => parcelRequire('jgKZU'));